export default __webpack_public_path__ + "static/media/c005-whatsapp-01-en.b21b0682.png";